"use client";
import React from "react";

export default function ArticleDate({ date }: { date: string }) {
  const [formatted, setFormatted] = React.useState<string>("");

  React.useEffect(() => {
    let active = true;
    import("luxon").then(({ DateTime }) => {
      if (active && date) {
        setFormatted(DateTime.fromISO(date).toFormat("MMM dd, yyyy"));
      }
    });
    return () => {
      active = false;
    };
  }, [date]);

  return <>{formatted}</>;
} 